import { Button } from '@/components/ui/button';

const WhatsAppButton = () => {
    const openWhatsApp = () => {
        window.open('https://wa.me/972559984337', '_blank');
    };

    return (
        <Button
            onClick={openWhatsApp}
            variant="ghost"
            size="icon"
            className="fixed bottom-28 left-6 z-50 hover:bg-transparent shadow-none w-12 h-12 transition-all duration-300 hover:scale-110 p-0 lg:hidden"
            aria-label="צור קשר בוואטסאפ"
        >
            <img
                src="/whatsapp-icon.png"
                alt="WhatsApp"
                className="w-full h-full object-contain drop-shadow-xl"
            />
        </Button>
    );
};

export default WhatsAppButton;
